import React, { useRef } from 'react';
import { Button } from 'devextreme-react';
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  Selection,
} from 'devextreme-react/data-grid';
import { FormatLineNumber, FormatNumber } from '../../common';
import { ExcelExport } from '../../common/excel';
import CorpListUseInfoPopupContainer from './corp-list-use-info-popup-container';
import CorpListExcelRegisterFilePopupContainer from './corp-list-excel-register-file-popup-container';
import CorpListDetailInfoPopupContainer from './corp-list-detail-info-popup-container';
import CorpListSelectedInfoPopupContainer from './corp-list-selected-info-popup-container';
import CorpListUpdateInfoPopupContainer from './corp-list-update-Info-popup-container';
import './corp-list.scss';

const CorpList = ({
  onSelectionChanged,
  onClickUseInfo,
  onClickExcelRegisterFile,
  onClickUserDetailInfo,
  onClickSelectedInfo,
  userList,
  totalInfo,
}) => {
  // console.log('CorpList Load');

  const refDataGid = useRef(null);

  return (
    <React.Fragment>
      <div className="corp-list">
        <h2 className="main-title">업소고객사용현황</h2>
        <div className="corp-list-top">
          <div className="corp-list-top-summary">
            {' '}
            사용자 목록
            <span className="font-10 gray">
              ( 총 사용자 : {totalInfo.user}명, 총 이용금액 :{' '}
              {FormatNumber(totalInfo.money)}원, 총 이용횟수 : {totalInfo.count}
              회 )
            </span>
          </div>
          <div className="corp-list-top-button">
            <Button
              className="corpListButtons"
              stylingMode="contained"
              type="success"
              text="전체사용자(Excel)"
              onClick={() =>
                ExcelExport(
                  refDataGid.current.instance,
                  '전체 사용자 등록 리스트.xlsx'
                )
              }
            />
            <Button
              stylingMode="contained"
              type="success"
              text="이용내역"
              onClick={onClickUseInfo}
            />
            <Button
              stylingMode="contained"
              type="success"
              text="등록(Excel)"
              onClick={onClickExcelRegisterFile}
            />
            <Button
              stylingMode="contained"
              type="danger"
              text="해지"
              onClick={onClickSelectedInfo}
            />
            <Button
              stylingMode="contained"
              type="default"
              text="등록"
              onClick={() => onClickUserDetailInfo({}, 'I')}
            />
          </div>
        </div>
        <DataGrid
          className={'dx-card wide-card'}
          columnAutoWidth={true}
          columnHidingEnabled={true}
          dataSource={userList}
          defaultFocusedRowIndex={0}
          focusedRowEnabled={true}
          keyExpr="Name"
          noDataText="업소고객사용자가 존재하지 않습니다."
          ref={refDataGid}
          showBorders={true}
          showColumnLines={true} // column 구분선
          onSelectionChanged={onSelectionChanged}
        >
          <Selection mode="multiple" showCheckBoxesMode="always" />
          <FilterRow visible={true} />
          <Column dataField="Name" caption="성명" alignment="left" />
          <Column
            dataField="LineNumber"
            caption="전화번호"
            alignment="center"
            customizeText={(e) => FormatLineNumber(e.value)}
          />
          <Column dataField="Part" caption="부서" alignment="left" />
          <Column dataField="Duty" caption="직책" alignment="left" />
          <Column
            dataField="UsageLimit"
            caption="월 이용한도"
            alignment="center"
          />
          <Column
            dataField="UsageHistory"
            caption="월 이용내역"
            alignment="right"
            cellRender={(cellData) => (
              <>
                {cellData.value.split('\r\n').map((text, index) => (
                  <div key={index}>{text}</div>
                ))}
              </>
            )}
          />
          <Column
            dataField="RemainingLimit"
            caption="월 잔여한도"
            alignment="center"
          />
          <Column
            dataField="PaymentStateText"
            caption="개별결제"
            alignment="center"
            // cellRender={this.PaymentStateCell}
          />
          <Column
            dataField="DatailInfo"
            caption="상세정보"
            alignment="center"
            cellRender={(cellData) => (
              <Button
                text="보기"
                icon="find"
                onClick={() => onClickUserDetailInfo(cellData.data, 'U')}
              />
            )}
          />
          <Paging defaultPageSize={10} />
          <Pager showPageSizeSelector={false} showInfo={true} />
        </DataGrid>
      </div>

      <CorpListUseInfoPopupContainer />
      <CorpListExcelRegisterFilePopupContainer />
      <CorpListDetailInfoPopupContainer />
      <CorpListSelectedInfoPopupContainer />
      <CorpListUpdateInfoPopupContainer />
    </React.Fragment>
  );
};

export default React.memo(CorpList);
